module.exports = __webpack_public_path__ + "static/media/team_4.f5aa2c52.jpg";